import { aludraApi } from 'api/axios'

const mdl22 = {
  catalog: 'mdl22/products/catalog',
  addUpdate: 'mdl22/products/catalog/addUpdate',
}

const mdl26 = {
  batchProcessFile: 'mdl26/batch/fromBlobFile',
}

// Procesa el CSV de precios e imágenes subido al blob (MDL26 -> MDL09 catalogProductsBulkUpload).
export const processCatalogBatchFileService = payload => {
  return aludraApi.post(mdl26.batchProcessFile, payload)
}

export const getQuickListCatalogService = productCustomListId => {
  return aludraApi.get(mdl22.catalog, {
    params: { productCustomListId },
  })
}

export const saveQuickListCatalogService = payload => {
  return aludraApi.post(mdl22.addUpdate, payload)
}
